import script from "./description.vue?vue&type=script&setup=true&lang=js"
export * from "./description.vue?vue&type=script&setup=true&lang=js"

import "./description.vue?vue&type=style&index=0&id=32e73ad0&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e73ad0"]])

export default __exports__